var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MobileMenu',{attrs:{"currentpage":this.currentpageid,"root":this.root,"apidomain":this.apidomain,"ocpApimSubscriptionKey":this.ocpApimSubscriptionKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }